import Column from '../../core/components/box/column';
import SizedBox from '../../core/components/box/sizedBox';
import { useTheme } from 'styled-components';
import LXMiddleButton from '../../core/components/buttons/lxMiddleButton';
import { LXCaption, LXh3 } from '../../core/texts/lxText';
import { ReactComponent as CheckedCircle } from '../../../assets/icons/check_circle.svg';
import { useNavigate } from 'react-router-dom';

const SuccessForm: React.FC = () => {
  const theme = useTheme();
  const naviate = useNavigate();

  const onConfirm = async () => {
    naviate('/signIn');
  };

  return (
    <Column alignItems="center">
      <CheckedCircle width={80}></CheckedCircle>
      <SizedBox height={30.67}></SizedBox>
      <LXh3>{theme.texts.passwordChanged}</LXh3>
      <SizedBox height={8}></SizedBox>
      <LXCaption>
        {theme.texts.yourPasswordHasBeenChangedSuccessfully}
      </LXCaption>
      <SizedBox height={24}></SizedBox>
      <LXMiddleButton onClick={onConfirm} width={132}>
        {theme.texts.backToSignIn}
      </LXMiddleButton>
    </Column>
  );
};

export default SuccessForm;
